import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Toggle.scss';

const Toggle = (props) => {
    const [isActive, setActive] = useState(props.isActive);

    useEffect(() => {
        setActive(props.isActive);
    }, [props.isActive]);

    const handleClick = () => {
        props.onClick(!isActive);

        if (!props.shouldNotOptimisticUpdate) {
            setActive(!isActive);
        }
    };

    const classes = classnames('toggle', {
        'toggle--active': isActive,
        'toggle--inactive': !isActive,
    });

    return (
        <button className={classes} onClick={handleClick}>
            <div className="toggle__outline" />
            {props.renderDisplayValue(isActive)}
        </button>
    );
};

Toggle.propTypes = {
    onClick: PropTypes.func,
    renderDisplayValue: PropTypes.func,
    isActive: PropTypes.bool,
    shouldNotOptimisticUpdate: PropTypes.bool,
};

export default Toggle;
